import { render, staticRenderFns } from "./newRefreshIcon.vue?vue&type=template&id=0a30eed4&scoped=true"
import script from "./newRefreshIcon.vue?vue&type=script&lang=js"
export * from "./newRefreshIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a30eed4",
  null
  
)

export default component.exports